import { Instance } from 'mobx-state-tree';
import { CreateCustomersFromOrdersErrorDtoModelBase } from './CreateCustomersFromOrdersErrorDtoModel.base';

/* The TypeScript type of an instance of CreateCustomersFromOrdersErrorDtoModel */
export interface CreateCustomersFromOrdersErrorDtoModelType extends Instance<typeof CreateCustomersFromOrdersErrorDtoModel.Type> {}

/* A graphql query fragment builders for CreateCustomersFromOrdersErrorDtoModel */
export { selectFromCreateCustomersFromOrdersErrorDto, createCustomersFromOrdersErrorDtoModelPrimitives, CreateCustomersFromOrdersErrorDtoModelSelector } from './CreateCustomersFromOrdersErrorDtoModel.base';

/**
 * CreateCustomersFromOrdersErrorDtoModel
 */
export const CreateCustomersFromOrdersErrorDtoModel = CreateCustomersFromOrdersErrorDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
